// Modules
import React, { useEffect, useState } from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { navigate } from "gatsby";

// Components
import HomeBanner from "../components/model/banner/home.jsx";
import FeaturedSection from "../components/model/FeaturedSection/FeaturedSection";
import Quicklinks from "../components/model/Quicklinks";
import WebsiteLayout from "../components/websiteLayout/index";
import WhyChooseUs from "../components/model/WhyChooseUs";
import Card from "../components/interface/Cards";
import { quicklinks } from "../data/quicklinks";

// Images
import broad from "./../images/homepage_banner.webp";
import TelecelPlay from "./../images/telecel_play.webp";
import Business from "./../images/business.webp";
import Cash from "../images/homepages/cash.webp";
import BroadbandImage from "../images/homepages/broadband.webp";
import VoiceData from "../images/homepages/voice-data.webp";
import ConnectedDevice from "../images/homepages/connected-device.webp";
import PreOrder from "../images/homepages/pre-order.webp";
import AllDevices from "../images/homepages/all-device.webp";
import Banner1 from "../images/banner_1.webp";
import Banner2 from "../images/business/more-money-promo.webp";
import InfinixPreOrder from "../images/mobile/infinix-preorder.webp";
import SMEBanner from "../images/sme/SME-Header.webp";
import CareBanner from "../images/care-month.webp";
import Banner3 from "../images/banner_3.webp";
import Banner5 from "../images/utilityBanner.webp";
import LogoWhite from "../images/Telecel-Icon-White.png";
import LogoRed from "../images/Telecel-Icon-Red.png";
import featuredBundle from "../data/featured-mobile-bundles.json";
import { getData } from "../services/users.js";
import { SEO } from "../components/layout/Seo/index.jsx";

// Main page
function IndexPage() {
  const [plans, setPlans] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  useEffect(() => {
    const plans = featuredBundle;
    // console.log("plans", plans)
    setPlans(plans);
    // getData().then((res) => {
    //   console.log("res", res)

    // })
  }, []);
  return (
    <WebsiteLayout>
      {!isLoaded && (
        <div className="container mx-auto">
          <div>
          <div className="mt-6 border rounded-lg border-border_lighter overflow-hidden">
            <div className="w-full p-20 md:p-60 bg-gray_200 animate-pulse"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 w-full gap-6 mt-6">
              <div>
              <div className="w-full p-20 rounded-lg md:p-40 bg-gray_200 animate-pulse"></div>
              </div>
              <div>
              <div className="w-full p-20 rounded-lg md:p-40 bg-gray_200 animate-pulse"></div>
              </div>
              <div>
              <div className="w-full p-20 rounded-lg md:p-40 bg-gray_200 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div onLoad={handleImageLoad} className={`pt-6 md:pt-10 transition-opacity duration-500 ${isLoaded ? "opacity-100" : "opacity-0"}`}>
        <HomeBanner
          bannerContent={[
            // {
            //   id: 3,
            //   title: "Telecel is Here!",
            //   // description: 'Introducing the iPhone 15 pro. Now with USB C, Titanium and most durable glass ever in an iPhone.',
            //   buttonText: "Learn more",
            //   buttonAction: "/explore-telecel/",
            //   overlay: true,
            //   transparentImage: true,
            //   isRevervseButton: true,
            //   backgroundImage: LogoWhite,
            //   className: "homepage-banner-1",
            // },
            {
              id: 2,
              title: "Join the Telecel More Money Promo and win MILLIONS",
              // description: 'Introducing the iPhone 15 pro. Now with USB C, Titanium and most durable glass ever in an iPhone.',
              buttonText: "Click to learn more",
              buttonAction: "/personal/mobile/promos/more-money-promo/",
              // overlay: true,
              overlayWhite: false,
              isRevervseButton: true,
              transparentImage: true,
              // className: "homepage-banner-4",
              backgroundImage: Banner2,
            },
            // {
            //   id: 3,
            //   title: "Pre-order Now!",
            //   // description: 'Introducing the iPhone 15 pro. Now with USB C, Titanium and most durable glass ever in an iPhone.',
            //   buttonText: "Learn more",
            //   buttonAction: "/personal/mobile/shop/pre-order",
            //   overlay: true,
            //   transparentImage: true,
            //   className: "homepage-banner-2",
            //   backgroundImage: LogoRed,
            //   // backgroundImage: SMEBanner,
            // },


            // {
            //   id: 1,
            //   title: "Telecel SME Month 2024",
            //   description: 'Connecting the woman in business',
            //   buttonText: "Learn more",
            //   buttonAction: "/business/sme",
            //   overlay: true,
            //   noTransparentImageClassnames: "h-111 md:h-130",
            //   backgroundImage: SMEBanner,
            // },
            {
              id: 1,
              title: <div>Connecting through care this Care Month</div>,
              // description: 'Connecting the woman in business',
              // buttonText: "Learn more",
              // buttonAction: "/business/sme",
              // overlay: true,
              overlayWhitee: true,
              // overlay:true,
              transparentImage: true,
              backgroundImage: CareBanner,
            },
            // {
            //   id: 3,
            //   title: "Telecel is Here!",
            //   // description: 'Introducing the iPhone 15 pro. Now with USB C, Titanium and most durable glass ever in an iPhone.',
            //   buttonText: "Learn more",
            //   buttonAction: "/explore-telecel/",
            //   overlay: true,
            //   transparentImage: true,
            //   isRevervseButton: true,
            //   backgroundImage: LogoWhite,
            //   className: "homepage-banner-1",
            // },
            {
              id: 3,
              title: "Make Life Simple! Pay your Utilities",
              // description: 'Pre-order your favourite Infinix phones with us!',
              buttonText: "Click here to login",
              buttonAction: `${process.env.play_base_url}/dashboard/`,
              overlayWhite: true,
              // overlay:true,
              Button: true,
              transparentImage: true,
              backgroundImage: Banner5,
            },
            // {
            //   id: 3,
            //   title: "Pre-order Now!",
            //   buttonText: "Learn more",
            //   buttonAction: "/personal/mobile/shop/pre-order",
            //   noTransparentImageClassnames:"h-111 md:h-130",
            //   backgroundImage: InfinixPreOrder,
            // },
          ]}
        />
      </div>
      <main className="w-screen overflow-hidden">
        <div className="container mx-auto mt-12 md:mt-16">
          <Quicklinks quicklink={quicklinks} />
        </div>
        <div className="container mx-auto mt-12 md:mt-16">
          {/* Deals section */}
          <div>
            <div className="pb-6 md:pb-7 flex flex-col md:flex-row gap-5 justify-between md:items-center">
              <div>
                <h2 className="text-heading_sm pb-1 font-bold text-brand">
                  Deals you can't resist.
                </h2>
                <p className="text-body_base">
                  Our devices come with data and voice bundles your wallet will
                  love.{" "}
                </p>
              </div>
              <div>
                <button
                  onClick={() => navigate("/personal/mobile/shop/devices")}
                  className=" bg-surface_brand fill-negative text-subtitle text-negative py-4 px-5 rounded-full"
                >
                  <span className="flex gap-2 items-center">
                    Visit Store
                    <ArrowRight color="" size={20} />
                  </span>
                </button>
              </div>
            </div>
            <div className="flex flex-col md:flex-row h-full gap-5">
              <Card
                link={() => navigate("/personal/mobile/shop/devices/")}
                imageSrc={PreOrder}
                title="Order your Samsung Galaxy A05 now! "
                description=""
                additionalContainerStyles="bg-surface_disabled max-h-70 md:max-h-full"
                imageStyles="!object-contain"
              />
              <div className="flex flex-col gap-5 justify-between w-full">
                <Card
                  link={() => navigate("/personal/mobile/shop/devices/")}
                  imageSrc={AllDevices}
                  title="All Devices"
                  description="Starting from GHc 800."
                  additionalContainerStyles="bg-surface_disabled h-70 md:h-full"
                  imageStyles="!object-contain"
                />
                <Card
                  link={() =>
                    navigate("/personal/mobile/shop/connected-devices/")
                  }
                  imageSrc={ConnectedDevice}
                  title="Connected Device"
                  description="Starting from GHc 750."
                  additionalContainerStyles="bg-surface_disabled h-70 md:h-full"
                  imageStyles="!object-contain"
                />
              </div>
            </div>
          </div>

          {/* SOlutions section */}
          <div className="mt-12 md:mt-16">
            <div className="pb-6 md:pb-7">
              <h2 className="text-heading_sm pb-1 font-bold text-brand">
                Making life easier.
              </h2>
              <p className="text-body_base">
                We've got a wide range of solutions.
              </p>
            </div>
            <div className="flex flex-col md:flex-row md:flex-wrap lg:flex-nowrap w-full gap-5">
              <Card
                id={"Voice_and_data"}
                link={() => navigate("/personal/mobile/offers/bundles/")}
                imageSrc={VoiceData}
                title="Voice and data"
                description="Affordable voice and date bundles to stay connected."
                additionalContainerStyles="bg-surface_disabled h-80 md:h-100 object-center"
              />
              <Card
                id={"Telecel_Cash"}
                link={() => navigate("/personal/telecel-cash/")}
                imageSrc={Cash}
                title="Telecel Cash"
                overlay={`bg-red_600`}
                description="Send and receive money and make payments with ease."
                additionalContainerStyles="bg-surface_disabled h-80 md:h-100 object-center"
              />
              <Card
                id={"Telecel_Broadband"}
                link={() => navigate("/personal/broadband/")}
                imageSrc={BroadbandImage}
                title="Telecel Broadband"
                description="High-speed fibre internet connectivity for your home."
                additionalContainerStyles="bg-surface_disabled h-80 md:h-100 object-center"
              />
            </div>
            <div className="pt-5">
              <Card
                id={"Business"}
                link={() => navigate("/business/")}
                imageSrc={Business}
                title="Telecel Business"
                description="We have got tailor made solutions for businesses of every size."
                additionalContainerStyles="bg-surface_disabled h-80 md:h-100"
                overlay={`bg-red_600`}
              />
            </div>
          </div>

          {/* Do more section */}
          <div className="mt-12 md:mt-16">
            <div className="pb-6 md:pb-7">
              <h2 className="text-heading_sm pb-1 font-bold text-brand">
                Telecel Play
              </h2>
              <p className="text-body_base">
                Take control with our self-care solution.
              </p>
            </div>
            <Card
              link={() => navigate(`${process.env.play_base_url}/dashboard/`)}
              imageSrc={TelecelPlay}
              title="Telecel Play"
              description="Manage your subscriptions, pay for bills, and do much more with our self service."
              additionalContainerStyles="bg-surface_disabled h-80 md:h-100"
            />
          </div>
        </div>
        <div className="mt-12 md:mt-16">
          <FeaturedSection
            buttonID={"Mobile_Bundles"}
            title="Stay connected with affordable data and voice bundles."
            description="We have got data, voice, and SMS bundles made for you."
            buttonTitle="View all plans"
            buttonAction="/personal/mobile/offers/bundles"
            plans={plans}
          />
        </div>
        <div className="container mx-auto mt-12 md:mt-16">
          <WhyChooseUs />
        </div>
      </main>
    </WebsiteLayout>
  );
}

// Export
export default IndexPage;

export const Head = () => (
  <SEO title={` Telecel Ghana - Home Page`} >
    {/* <title> Telecel Ghana - Home Page</title> */}
    {/* <meta
      name="google-site-verification"
      content="E4zHPdFM5phEVG5FTo9P1AXCBMButLg_5DIyUX6-2N0"
    />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context" : "https://schema.org",
          "@type" : "WebSite",
          "name" : "Telecel Ghana",
          "url" : "https://telecel.com.gh/"
        }`,
      }}
    /> */}
  </SEO>
);
